module.exports = __webpack_public_path__ + "img/ewh-1.83647127.jpg";